export const sortByProperty = (property) => {
    return function (a, b) {
        if (a[property] > b[property]) return 1
        else if (a[property] < b[property]) return -1
        return 0
    }
}

export const sortByProprtyInteger = (property) => {
    return function (a, b) {
        if (parseInt(a[property]) > parseInt(b[property])) return 1
        else if (parseInt(a[property]) < parseInt(b[property])) return -1
        return 0
    }
}
